// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import {
    filterCollection,
    sortCollection
} from '../../../../shared/services/collections';
import Accordion from '../../../../shared/components/accordion';
import {FormattedMessage} from 'react-intl';
import SearchFilters from '../../../../shared/state/search-filters';
import SpaClaimForApproval from '@deere/cps-it.warranty-model-factory/lib/claim-for-approval-summary';
import SpaList from './spa-list';
import {buildNumber} from '../../../../shared/services/build-number';
import spaClaimsFilterOptions from '../../services/spa-claims-filter-options';

function handleExportToExcel() {

    this.actions.exportSpaClaims();

}

function handleFilterByChange(filterBy) {

    this.actions.updateSpaClaimsListFilterBy(filterBy);

}

function handleSortByChange(sortBy) {

    this.actions.updateSpaClaimsListSortBy(sortBy);

}

function handleSortDirectionChange(sortDirection) {

    this.actions.updateSpaClaimsListSortDirection(sortDirection);

}

const SpecialAllowanceAccordion = props => {

    let sortedCollection;

    sortedCollection = [...props.spaClaims];
    sortedCollection = sortCollection(props.spaClaimsSearchFilters.sortBy, props.spaClaimsSearchFilters.sortDirection, sortedCollection);
    sortedCollection = filterCollection(props.spaClaimsSearchFilters.filterBy, spaClaimsFilterOptions, sortedCollection);

    const body = (
        <SpaList
            hasResults={props.spaClaims.length > 0}
            onExport={handleExportToExcel.bind(props)}
            spaClaims={sortedCollection}
            spaClaimsSearchFilters={props.spaClaimsSearchFilters}
            updateListFilterBy={props::handleFilterByChange}
            updateListSortBy={props::handleSortByChange}
            updateListSortDirection={props::handleSortDirectionChange}
        />
    );

    const title = (
        <FormattedMessage
            id='SPECIAL_ALLOWANCE_CLAIMS_WITH_COUNT'
            values={{
                count: buildNumber(sortedCollection.length)
            }}
        />
    );

    return props.spaClaims.length > 0 &&
        <Accordion
            accordionId='special-allowance-accordion'
            body={body}
            secondaryHeaderNode={null}
            title={title}
        />;

};

SpecialAllowanceAccordion.displayName = 'SpecialAllowanceAccordion';
SpecialAllowanceAccordion.propTypes = {
    actions: PropTypes.object.isRequired,
    spaClaims: PropTypes.arrayOf(PropTypes.instanceOf(SpaClaimForApproval)).isRequired,
    spaClaimsSearchFilters: PropTypes.instanceOf(SearchFilters).isRequired
};

export default SpecialAllowanceAccordion;



// WEBPACK FOOTER //
// ./src/tabm/wip/components/special-allowance/spa-accordion.js